const toUserTimezoneFilter = function (moment, UserService) {
  'ngInject'

  return function (tzValue, format = 'short') {
    // Handle undefined/null first
    if (typeof tzValue === 'undefined' || tzValue === null) {
      return 'Unknown'
    }

    // Handle utcOffsetInHours format
    if (format === 'utcOffsetInHours') {
      // If it's a string (timezone name), return the timezone name
      if (typeof tzValue === 'string') {
        return tzValue // Return the timezone name (e.g., "Asia/Calcutta")
      }
      // Handle numeric offset (legacy) - convert to UTC format
      const hours = Math.abs(Math.round(tzValue / 60))
      const prefix = tzValue <= 0 ? '+' : '-'
      return `UTC ${prefix}${hours}`
    }

    // Handle time display formats (short, etc.)
    let displayFormat = format
    if (format === 'short') {
      displayFormat = 'ddd, hh:mma'
    }

    // If tzValue is a string, treat as timezone name
    if (typeof tzValue === 'string') {
      // Use moment-timezone if available
      if (moment.tz) {
        // Get current time in the target timezone
        return moment().tz(tzValue).format(displayFormat)
      } else {
        // Fallback: convert to the target timezone using browser APIs
        try {
          const now = new Date()
          const targetTime = new Date(now.toLocaleString('en-US', { timeZone: tzValue }))
          return moment(targetTime).format(displayFormat)
        } catch (error) {
          console.warn('[toUserTimezone] Could not convert time for timezone:', tzValue, error)
          return moment().format(displayFormat) // fallback to current time
        }
      }
    }

    // Otherwise, treat as offset (legacy)
    const d = new Date()
    const utc = d.getTime() + (d.getTimezoneOffset() * 60000)
    const nd = new Date(utc - (60000 * tzValue))
    return moment(nd).format(displayFormat)
  }
}
export default toUserTimezoneFilter
